module.exports = __webpack_public_path__ + "img/logo.d0e50f35.png";